<template>
  <div class="foundation">
    <b-container
      class="foundation-container"
      fluid
      style="padding: 0px !important;"
    >
      <b-row class="no-gutters">
        <b-col class="d-flex flex-column" sm="5">
          <div class="foundation-header d-flex p-2">
            <level-dropdown></level-dropdown>

            <div
              class="align-middle d-flex align-items-center foundation-header-title"
            >
              Excercise {{ level.level }}: {{ level.title }}
            </div>
          </div>
          <div class="foundation-content">
            <h2>Introduction to Loops</h2>
            <p>
              Loops are used to instruct computer to do something over and over
              again. This is what makes a computer so powerful in carrying out
              repetitive task. A computer can repeat a line of code million
              times in a second! There are two main type of loop we can use in
              all programming languages.
            </p>

            <h5>For Loop</h5>
            <p>
              A FOR loop will carry out instructions for a given number of
              times. For example in code below, the code inside FOR loop will be
              run 5 times.
            </p>
            <img :src="`${publicPath}img/level_4_1.png`" />

            <h5>While Loop</h5>
            <p>
              Another main loops used heavily in programming is the WHILE Loop.
              A while loop will run again and again if a given is TRUE, until at
              some point the condition is FALSE then it will stop. For example
              in code below, the WHILE loop will run as long as myNumber
              variable is less than 10. Every time the the loop run, we will add
              1 to myNumber until it reaches 10. Then the loop will stop.
            </p>
            <img :src="`${publicPath}img/level_4_2.png`" />

            <div class="activity-header my-3">
              Activity
            </div>
            <ol>
              <li>
                Inside the for loop, set
                <span class="variable">myNumber</span> to add
                <span class="number">26</span> to itself
              </li>
              <li>Set the loop to repeat 8 times</li>
            </ol>
          </div>
        </b-col>
        <b-col>
          <div class="foundation-actionbar d-flex justify-content-end">
            <b-button class="my-auto mr-2" @click="viewCode">
              View Code
            </b-button>
            <b-button
              variant="danger"
              class="my-auto mr-2"
              @click="resetWorkspace"
            >
              Reset
            </b-button>
            <b-button variant="primary" class="my-auto mr-2" @click="runCode">
              <font-awesome-icon
                class="mr-2"
                :icon="['fas', 'play']"
                style="color: white;"
              />Run
            </b-button>
          </div>
          <div id="blocklyDiv"></div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="showCode" title="JavaScript Code">
      <p class="my-4" style="white-space:pre-wrap;">
        {{ code }}
      </p>
    </b-modal>

    <b-modal
      v-model="showResultModal"
      title="Code result"
      @ok="onClickResultModalOk"
    >
      <div class="text-center">
        <h3>
          {{ isResultCorrect ? "Correct" : "Wrong" }}
        </h3>
        <p class="my-4" style="white-space:pre-wrap;">
          {{ resultMessage }}
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import LevelDropdown from "@/components/LevelDropdown.vue";
import Blockly from "blockly";
import Interpreter from "js-interpreter";
import LevelRepository from "@/repositories/level-repository";

import UserServices from "@/services/user-services";
import { mapState } from "vuex";

export default {
  name: "loop-one",

  components: {
    LevelDropdown
  },

  data() {
    return {
      id: this.$route.params.id,
      publicPath: process.env.BASE_URL,
      workspace: null,
      code: "",
      showCode: false,
      showResultModal: false,
      isResultCorrect: false,
      resultMessage: "",
      levels: [],
      level: {
        level: "",
        title: "",
        toolbox: null
      },
      result: {}
    };
  },

  mounted() {
    this.getLevels();
    this.getLevel();
    this.injectBlockly();
  },

  computed: {
    ...mapState(["user"])
  },

  methods: {
    initPage() {
      this.removeBlocklyInjection();
      this.getLevels();
      this.getLevel();
      this.injectBlockly();
    },

    injectBlockly() {
      this.workspace = Blockly.inject(document.getElementById("blocklyDiv"), {
        trashcan: true,
        toolbox: this.level.toolbox
      });

      if (this.level.workspace != undefined) {
        let workspaceBlock = Blockly.Xml.textToDom(this.level.workspace);
        Blockly.Xml.domToWorkspace(workspaceBlock, this.workspace);
      }
    },

    getLevel() {
      this.level = LevelRepository.getLevel(this.id);
    },

    getLevels() {
      this.levels = LevelRepository.getLevels();
    },

    viewCode() {
      this.code = Blockly.JavaScript.workspaceToCode(this.workspace);
      this.showCode = true;
    },

    resetWorkspace() {
      if (confirm("Are you sure you want to reset this question?")) {
        this.result = {};
        document.getElementById("blocklyDiv").innerHTML = "";
        this.injectBlockly();
      }
    },

    removeBlocklyInjection() {
      document.getElementById("blocklyDiv").innerHTML = "";
    },

    runCode() {
      let workspaceCode = Blockly.JavaScript.workspaceToCode(this.workspace);
      let code = this.appendCode(workspaceCode);
      let myInterpreter = new Interpreter(code, this.getInitApi());
      myInterpreter.run();
      this.checkResult();
    },

    appendCode(code) {
      code += "try {returnResult(myNumber);} catch (err) {};";
      return code;
    },

    getInitApi() {
      const self = this;
      return (interpreter, scope) => {
        const wrapper = function(myNumber) {
          self.result = {
            myNumber: myNumber
          };
        };
        interpreter.setProperty(
          scope,
          "returnResult",
          interpreter.createNativeFunction(wrapper)
        );
      };
    },

    checkResult() {
      const self = this;
      const answer = 26 * 8;
      self.isResultCorrect = false;

      if (this.result.myNumber === undefined) {
        self.resultMessage = "myNumber is not created correctly";
      } else if (this.result.myNumber.data === answer) {
        this.isResultCorrect = true;
        self.resultMessage = "Great! Let move on to the next task.";

        if (this.user.uid != "") {
          this.updateUserDoneActivity();
        }
      } else {
        self.resultMessage = "Wrong value for myNumber";
      }
      self.showResultModal = true;
    },

    onClickResultModalOk() {
      if (this.isResultCorrect) {
        let nextLevel = parseInt(this.id) + 1;
        this.$router.push("/foundation/" + nextLevel);
      } else {
        this.showResultModal = false;
      }
    },

    async updateUserDoneActivity() {
      await UserServices.updateUserDoneActivity(
        this.user.uid,
        this.level.firebaseId,
        "foundation"
      );
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    this.initPage();
    next();
  }
};
</script>

<style lang="less" scoped>
.foundation {
  &-header {
    background-color: rgb(255, 223, 137);

    &-title {
      line-height: 1.25rem;
      font-size: 1.25rem;
    }
  }

  &-content {
    padding: 15px;
    overflow: auto;
    height: calc(100vh - 120px);
  }

  &-actionbar {
    height: 54px;
  }
}

#blocklyDiv {
  height: calc(100vh - 110px);
  width: 100%;
}
</style>
